import { Component, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OtherService } from 'app/infrastructure/services/catalog/otros.service';
import Swal from 'sweetalert2';
import { PartnerService } from '@infrastructure/services/alpura/partner.service';

@Component({
  selector: 'app-nuevo-socio',
  templateUrl: './nuevo-socio.component.html',
  styleUrls: ['./nuevo-socio.component.scss']
})

export class NuevoSocioComponent implements OnInit {
  idUpdate: any;
  listAccountBank = [];
  partner: any;

  editarForm: UntypedFormGroup = this.formBuilder.group(
    {
      planta: ['', [Validators.required]],
      noSocio: ['', [Validators.required]],
      levelPartner: [''],
      typePartner: [''],
      supplierType: [''],
      razonSocial: [''],
      nombre: [''],
      rfc: [''],
      curp: [''],
      grupoAparceria: [''],
      regRecolec: [''],
      grupoArrendador: [''],
      particArrend: [''],
      zonaGeografica: [''],
      estado: [''],
      municipio: [''],
      region: [''],
      direccion: [''],
      email: [''],
      tel1: [''],
      tel2: [''],
      tel3: [''],
      cp: [''],
      typePerson: [''],
      ruta: [''],
      socioContrato: [''],
      noAcciones: [''],
      premioFDA: ['2'],
      flete: [''],
      compensacion: [''],
      premioBPP: ['NO'],
      tipoEstatus: [''],
      logId: [''],
      ranchAddress: ['']
    }
  );



  listaPlantas = [];
  listaReg = [];
  listaStates = [];
  listaMunicipio: any = [];
  listaRutaRecolecion = [];
  listaRutasParaDescripcion = [];
  listaZonasGeograficas: any = [];
  listaTipoSocio: any = [];
  listaGrupoAparceria: any = [];
  listaTipoPersona: any = [];
  listaGrupoArrendador: any = [];
  listaNivelSocio: any = [];
  listaGrupoCompensacionLogistica = [];

  status: any[] = [
    { valor: 1, texto: 'Activo' },
    { valor: 2, texto: 'Baja' }
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private _share: PartnerService,
    private formBuilder: FormBuilder,
    public _other: OtherService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.editarForm.get('planta')?.disable();
    this.editarForm.get('noSocio')?.disable();

    this.editarForm.get('premioBPP')?.disable();
    this.editarForm.get('premioFDA')?.disable();

    this.activatedRoute.params.subscribe((params: any) => {

      this.idUpdate = params.num;

      this._share.getSocioById({ id: this.idUpdate }).subscribe(async (res: any) => {
        this.partner = res;
        this._share.getBankAccountByPartner(this.partner.id).subscribe(async (res: any) => {
          this.listAccountBank = res;
        });

        this.editarForm = this.formBuilder.group(
          {
            planta: [this.partner.idFacility, [Validators.required]],
            noSocio: [this.partner.partnerNumber, [Validators.required]],
            levelPartner: [this.partner.partnerLevel],
            typePartner: [this.partner.partnerType],
            supplierType: [this.partner.supplierType],
            razonSocial: [this.partner.bussinessName],
            nombre: [this.partner.partnerName],
            rfc: [this.partner.rfc],
            curp: [this.partner.curp],
            grupoAparceria: [this.partner.sharecroppingGroup],
            regRecolec: [this.partner.idCollectionRegion],
            grupoArrendador: [this.partner.lessorGroup],
            particArrend: [this.partner.leaseParticipation],
            zonaGeografica: [this.partner.geographicalArea],
            estado: [this.partner.state],
            municipio: [this.partner.municipality],
            region: [this.partner.idRegion],
            direccion: [this.partner.fisicalAddress],
            email: [this.partner.email],
            tel1: [this.partner.phone1],
            tel2: [this.partner.phone2],
            tel3: [this.partner.phone3],
            cp: [this.partner.cp],
            typePerson: [this.partner.personType],
            ruta: [this.partner.idPickRoute],
            socioContrato: [this.partner.partnerContract],
            noAcciones: [this.partner.sharesNumber],
            premioFDA: [this.partner.awardCertificate],
            flete: [this.partner.freight],
            compensacion: [this.partner.compensationGroup],
            premioBPP: [this.partner.awardBPP],
            tipoEstatus: [this.partner.status],
            logId: [this.partner.logId],
            ranchAddress: [this.partner.ranchAddress]
          }
        );

        this.handleChangeEstado(this.partner.state);
        this.validaEstatus(this.partner.status);
      });
    });

    this.obtenerGruposCompensacion();
    this.obtenerGrupoArrendador();

    this._share.getPlantas().subscribe(async (res: any) => {
      this.listaPlantas = res;
    });

    this._share.getZonasGeograficas().subscribe(async (res: any) => {
      this.listaZonasGeograficas = res;
    });
    this.obtenerTipoSocio();

    this._share.getGrupoAparceria().subscribe(async (res: any) => {
      this.listaGrupoAparceria = res;
    });

    this._share.getTipoPersona().subscribe(async (res: any) => {
      this.listaTipoPersona = res;
    });

    this._share.getCatRegiones().subscribe(async (res: any) => {
      this.listaReg = res;
    })

    this._share.getCatRutasRecoleccion().subscribe(async (res: any) => {
      this.listaRutasParaDescripcion = res;
    });

    this._share.getRegionesRecoleccion().subscribe(async (res: any) => {
      this.listaRutaRecolecion = res;
    });

    this._share.getCatStates().subscribe(async (res: any) => {
      this.listaStates = res;
    });

    this.obtenerNivelSocio();
  }

  obtenerGrupoArrendador() {
    this.listaGrupoArrendador.length = 0;

    this._other.catSearchSet("Grupo_Arrendador").subscribe(async (s: any) => {
      s.valueSetDetailResponse.forEach((item: any) => {
        this.listaGrupoArrendador.push({
          cveValue: item.cveValue,
          description: item.description,
          activo: item.activo
        });
      });
    },
      error => {
        this.listaGrupoArrendador.length = 0;
      });
  }

  obtenerNivelSocio() {
    this.listaNivelSocio.length = 0;

    this._other.catSearchSet("ALP_NIVEL_DEL_SOCIO").subscribe(async (s: any) => {
      s.valueSetDetailResponse.forEach((item: any) => {
        this.listaNivelSocio.push({
          cveValue: item.cveValue,
          description: item.description,
          activo: item.activo
        });
      });
    },
      error => {
        this.listaNivelSocio.length = 0;
      });
  }


  obtenerGruposCompensacion(){
    this.listaGrupoCompensacionLogistica = [];

    this._other.catSearchSet("ALP_GRUPO_COMPENSACION").subscribe(async (s: any) => {
      this.listaGrupoCompensacionLogistica = s.valueSetDetailResponse.map((m: any) => {
        return {
          cveValue: m.cveValue,
          description: m.description,
          activo: m.activo
        } as any;
      }).filter((f: any) => f.activo === 1);
    },
      error => {
        this.listaGrupoCompensacionLogistica = [];
      });
  }


  obtenerTipoSocio() {
    this.listaTipoSocio.length = 0;

    this._other.catSearchSet("ALP_TIPO_SOCIO").subscribe(async (s: any) => {
      s.valueSetDetailResponse.forEach((item: any) => {
        this.listaTipoSocio.push({
          cveValue: item.cveValue,
          description: item.description,
          activo: item.activo
        });
      });
    },
      error => {
        this.listaTipoSocio.length = 0;
      });
  }

  handleChangeEstado(id: string) {
    this.listaMunicipio.length = 0;

    this._share.getCatMunicipio(id.toString()).subscribe(async (res: any) => {
      res.forEach((item: any) => {
        this.listaMunicipio.push({
          cveEnt: item.cveEnt,
          cveMun: item.cveMun,
          nomMun: item.nomMun
        });
      });
    })
  }

  showRegresarSocio() {
    Swal.fire({
      icon: 'question',
      title: 'Esta a punto de salir',
      text: "¿Deseas guardar tus cambios?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Si',
      denyButtonText: `No`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.showGuardarSocio();
      } else if (result.isDenied) {
        this.router.navigate([`/catalog/maestro-socios`]);
      }
    })
  }

  showGuardarSocio() {
    let form = this.editarForm.value;
    let params1: any;

    if (form.tipoEstatus == 2) {
      this.partner.status = this.editarForm.value.tipoEstatus;

      this._share.updatePartner(this.partner, this.idUpdate).subscribe(
        (data: any) => {

          Swal.fire({ icon: 'success', title: 'Aviso', html: `<b>Se actualizaron los datos!</b>` })

          this.router.navigate(["/catalog/maestro-socios"])

        },
        (err: any) => {
          console.log(err)
          if (err.status == 409) {
            Swal.fire({ icon: 'error', title: 'Aviso', html: `<b>Dato ya existe</b>` })
          } else {
            Swal.fire({ icon: 'error', title: 'Aviso', html: `<b>Error en el servidor</b>` })
          }
        },
      );
    }

    if (form.tipoEstatus == 1) {

      this.partner.idFacility = this.editarForm.value.planta;
      this.partner.partnerNumber = this.editarForm.value.noSocio;
      this.partner.partnerLevel = this.editarForm.value.levelPartner;
      this.partner.partnerType = this.editarForm.value.typePartner;
      this.partner.supplierType = this.editarForm.value.supplierType;
      this.partner.bussinessName = this.editarForm.value.razonSocial;
      this.partner.partnerName = this.editarForm.value.nombre;
      this.partner.rfc = this.editarForm.value.rfc;
      this.partner.curp = this.editarForm.value.curp;
      this.partner.sharecroppingGroup = this.editarForm.value.grupoAparceria;
      this.partner.idCollectionRegion = this.editarForm.value.regRecolec;
      this.partner.lessorGroup = this.editarForm.value.grupoArrendador;
      this.partner.leaseParticipation = this.editarForm.value.particArrend;
      this.partner.geographicalArea = this.editarForm.value.zonaGeografica;
      this.partner.state = this.editarForm.value.estado;
      this.partner.municipality = this.editarForm.value.municipio;
      this.partner.idRegion = this.editarForm.value.region;
      this.partner.fisicalAddress = this.editarForm.value.direccion;
      this.partner.ranchAddress = this.editarForm.value.ranchAddress;
      this.partner.cp = this.editarForm.value.cp;
      this.partner.email = this.editarForm.value.email;
      this.partner.phone1 = this.editarForm.value.tel1;
      this.partner.phone2 = this.editarForm.value.tel2;
      this.partner.phone3 = this.editarForm.value.tel3;
      this.partner.personType = this.editarForm.value.typePerson;
      this.partner.idPickRoute = this.editarForm.value.ruta;
      this.partner.partnerContract = this.editarForm.value.socioContrato;
      this.partner.sharesNumber = this.editarForm.value.noAcciones;
      this.partner.awardCertificate = this.editarForm.value.premioFDA;
      this.partner.freight = this.editarForm.value.flete;
      this.partner.compensationGroup = this.editarForm.value.compensacion;
      this.partner.awardBPP = this.editarForm.value.premioBPP;
      this.partner.status = this.editarForm.value.tipoEstatus;
      this.partner.logId = this.editarForm.value.logId;


      this._share.updatePartner(this.partner, this.idUpdate).subscribe(
        (data: any) => {

          Swal.fire({ icon: 'success', title: 'Aviso', html: `<b>Se actualizaron los datos!</b>` })

          this.router.navigate(["/catalog/maestro-socios"])

        },
        (err: any) => {
          if (err.status == 409) {
            Swal.fire({ icon: 'error', title: 'Aviso', html: `<b>Dato ya existe</b>` })
          } else {
            Swal.fire({ icon: 'error', title: 'Aviso', html: `<b>Error en el servidor</b>` })
          }
        },
      );
    }
  }

  validaEstatus(e: any) {
    if (e == 1) {
      this.editarForm.get('levelPartner')?.enable();
      this.editarForm.get('typePartner')?.enable();
      this.editarForm.get('supplierType')?.enable();
      this.editarForm.get('razonSocial')?.enable();
      this.editarForm.get('nombre')?.enable();
      this.editarForm.get('rfc')?.enable();
      this.editarForm.get('curp')?.enable();
      this.editarForm.get('grupoAparceria')?.enable();
      this.editarForm.get('regRecolec')?.enable();
      this.editarForm.get('grupoArrendador')?.enable();
      this.editarForm.get('particArrend')?.enable();
      this.editarForm.get('zonaGeografica')?.enable();
      this.editarForm.get('estado')?.enable();
      this.editarForm.get('municipio')?.enable();
      this.editarForm.get('region')?.enable();
      this.editarForm.get('direccion')?.enable();
      this.editarForm.get('email')?.enable();
      this.editarForm.get('tel1')?.enable();
      this.editarForm.get('tel2')?.enable();
      this.editarForm.get('tel3')?.enable();
      this.editarForm.get('cp')?.enable();
      this.editarForm.get('typePerson')?.enable();
      this.editarForm.get('ruta')?.enable();
      this.editarForm.get('socioContrato')?.enable();
      this.editarForm.get('noAcciones')?.enable();
      this.editarForm.get('premioFDA')?.enable();
      this.editarForm.get('flete')?.enable();
      this.editarForm.get('compensacion')?.enable();
      this.editarForm.get('premioBPP')?.enable();
      this.editarForm.get('tipoEstatus')?.enable();
      this.editarForm.get('logId')?.enable();
    }
    if (e == 2) {


      this.editarForm.get('levelPartner')?.disable();
      this.editarForm.get('typePartner')?.disable();
      this.editarForm.get('supplierType')?.disable();
      this.editarForm.get('razonSocial')?.disable();
      this.editarForm.get('nombre')?.disable();
      this.editarForm.get('rfc')?.disable();
      this.editarForm.get('curp')?.disable();
      this.editarForm.get('grupoAparceria')?.disable();
      this.editarForm.get('regRecolec')?.disable();
      this.editarForm.get('grupoArrendador')?.disable();
      this.editarForm.get('particArrend')?.disable();
      this.editarForm.get('zonaGeografica')?.disable();
      this.editarForm.get('estado')?.disable();
      this.editarForm.get('municipio')?.disable();
      this.editarForm.get('region')?.disable();
      this.editarForm.get('direccion')?.disable();
      this.editarForm.get('email')?.disable();
      this.editarForm.get('tel1')?.disable();
      this.editarForm.get('tel2')?.disable();
      this.editarForm.get('tel3')?.disable();
      this.editarForm.get('cp')?.disable();
      this.editarForm.get('typePerson')?.disable();
      this.editarForm.get('ruta')?.disable();
      this.editarForm.get('socioContrato')?.disable();
      this.editarForm.get('noAcciones')?.disable();
      this.editarForm.get('premioFDA')?.disable();
      this.editarForm.get('flete')?.disable();
      this.editarForm.get('compensacion')?.disable();
      this.editarForm.get('premioBPP')?.disable();
      this.editarForm.get('tipoEstatus')?.enable();
      this.editarForm.get('logId')?.disable();


    }
  }



  eventTipoSocio(event: any) {

    if (parseInt(event) === 1) {
      this.editarForm.get('supplierType')?.disable();
    } else {
      this.editarForm.get('supplierType')?.enable();
    }
  }
}
